
    /**
    * 分销员业绩列表
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid18167 {
  /**
   * bd组名
   */
  name?: string | number;
  /**
   * 组编号
   */
  bdGroupCode?: string | number;
  bdCode?: string | number;
  /**
   * 省份province_id
   */
  provinceCode?: string | number;
  index?: string | number;
  size?: string | number;
}
  /**
 * YResult<YListData<DistributionBdDTO>> :YResult
 */
export class IResid18167 {
  code?: {};
  msg?: {};
  success?: {};
  /**
   * YListData
   */
  data?: {
    /**
     * T
     */
    list?: {
      /**
       * 组编号
       */
      bdGroupCode?: {};
      /**
       * BD组名称
       */
      bdGroupName?: {};
      /**
       * bd编号
       */
      bdCode?: {};
      /**
       * bd名称
       */
      bdName?: {};
      /**
       * 拥有主播数
       */
      anchorNum?: {};
      /**
       * 已直播场数
       */
      overLiveNum?: {};
      /**
       * 待直播场数
       */
      waitLiveNum?: {};
      /**
       * 直播转化率
       */
      liveConversionRate?: {};
      /**
       * 复播率
       */
      rebroadcastRate?: {};
      /**
       * 总gvm
       */
      totalGMV?: {};
      /**
       * 周环比增长
       */
      weekRate?: {};
      /**
       * 月环比增长
       */
      monthRate?: {};
    }[];
    totalNumber?: {};
    rowId?: {};
  };
  exceptionMsg?: {};
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid18167, IResid18167['data'] > = (data?) =>  request({
        method: 'GET',
        url: '/bdGroup/list/performance',
        params: data
      }) 
  export default http